module.exports = __webpack_public_path__ + "media/18.5791434a.mp3";